import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters();

    return (filters.length > 0 && (
        <div className="bg-white flex gap-3.5 overflow-scroll no-scrollbar w-full mb-5 lg:mb-7 lg:gap-3 lg:items-center">
            <button
                type="button"
                className="-mt-1 flex items-center underline-offset-[5px] lg:items-end h7 text-gray-900 whitespace-nowrap underline"
                aria-label="Clear all current filters"
                onClick={removeAll}
            >
                Clear All
            </button>
            <ul className="flex gap-3 h-7">
                {filters.map(filter => (
                    <li>
                        <button
                            className="relative flex items-center h7 block py-1 pl-2.5 bg-core-1 pr-7 whitespace-nowrap"
                            onClick={() => filter.remove()}
                        >
                            <span>{filter.value}</span>
                            <span
                                className="absolute cursor-pointer right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 before:absolute before:bg-gray-900 before:origin-center before:block before:w-2 before:h-[1px] before:rotate-45 before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before: after:absolute after:bg-gray-900 after:origin-center after:block after:w-2 after:h-[1px] after:-rotate-45 after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2"
                            ></span>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    ))
}
